// WINDOW SIZE

// measure width and height of the app
// run once on startup/resize and then reuse the same value

export let windowWidth;
export let windowHeight;
export let containerWidth;
export let rem;

const bg = document.getElementById("background");
const bodyStyle = window.getComputedStyle(document.body);

function resize() {
  rem = parseFloat(bodyStyle.getPropertyValue("font-size"));

  windowWidth = window.innerWidth;
  windowHeight = bg.offsetHeight;
  const fontScale = 0.04;
  containerWidth = windowWidth > 612 ? 612 : windowWidth * 0.85;
  const offset = fontScale * containerWidth - 16; // 16px default browser font size
  const bodyFontSize = `calc(100% + ${offset}px)`;
  document.documentElement.style.fontSize = bodyFontSize;
}

function setup() {
  window.addEventListener("resize", resize);
  resize();
}

window.addEventListener("load", setup);
